import { createSelector } from 'reselect';

const getAuth = state => state;

export default createSelector(
  getAuth,
  (auth) => auth.loggedIn && auth.user.roles.includes("ROLE_RIFF_USER")
)